/* Банерите на началната (sections/t4-banneri.liquid): стрелки, точки, плъзгане с пръст и сама смяна.
   Лентата е родно хоризонтално превъртане с прилепване (scroll-snap) - плъзгането с пръст работи и без този файл;
   тук са стрелките, точките, смяната на N секунди и „inert“ на скритите банери (бутонът им не се хваща с Tab).
   Сама смяна няма при „намалено движение“ в системата; спира завинаги при първо пипане от човека. */
(function () {
  function init(sek) {
    if (!sek || sek.dataset.t4Gotov) return;
    var lenta = sek.querySelector('[data-lenta]');
    var slaidove = Array.prototype.slice.call(sek.querySelectorAll('[data-slaid]'));
    if (!lenta || slaidove.length < 2) return;
    sek.dataset.t4Gotov = '1';
    var nazad = sek.querySelector('[data-nazad]');
    var napred = sek.querySelector('[data-napred]');
    var tochki = Array.prototype.slice.call(sek.querySelectorAll('[data-tochka]'));
    var kutia = sek.querySelector('[data-tochki]');
    var maloDvizhenie = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var avto = maloDvizhenie ? 0 : (parseInt(sek.getAttribute('data-avto'), 10) || 0);
    var tekusht = 0;
    var taimer = null;
    var pauza = false;

    function sredata() {
      var k = slaidove[tekusht].querySelector('.t4-banneri__kadar');
      if (k && k.offsetHeight) sek.style.setProperty('--t4-banneri-sredata', (k.offsetTop + k.offsetHeight / 2) + 'px');
    }
    function oznachi(i) {
      tekusht = i;
      slaidove.forEach(function (s, j) {
        if (j === i) s.removeAttribute('inert'); else s.setAttribute('inert', '');
      });
      tochki.forEach(function (t, j) { t.setAttribute('aria-current', j === i ? 'true' : 'false'); });
      sredata();
    }
    /* снимките на банерите чакат load (snippets/t4-kasni-snimki.liquid) - смяна или докосване иска веднага
       показвания банер и съседите му, не всичките наведнъж */
    function snimka(j) {
      var n = slaidove.length;
      var img = slaidove[((j % n) + n) % n].querySelector('img');
      if (img && sek.t4Vrani) sek.t4Vrani(img);
    }
    function idi(i, bezAnimacia) {
      var n = slaidove.length;
      i = ((i % n) + n) % n;
      snimka(i);
      snimka(i + 1);
      lenta.scrollTo({ left: i * lenta.clientWidth, behavior: (bezAnimacia || maloDvizhenie) ? 'auto' : 'smooth' });
      oznachi(i);
    }
    function spri() {
      snimka(tekusht - 1);
      snimka(tekusht + 1);
      if (taimer) { clearInterval(taimer); taimer = null; }
    }

    nazad.hidden = false;
    napred.hidden = false;
    if (kutia) kutia.hidden = false;
    nazad.addEventListener('click', function () { spri(); idi(tekusht - 1); });
    napred.addEventListener('click', function () { spri(); idi(tekusht + 1); });
    tochki.forEach(function (t, j) { t.addEventListener('click', function () { spri(); idi(j); }); });

    // плъзгане с пръст или колелцето: банерът, на който лентата е спряла
    var chakane = null;
    lenta.addEventListener('scroll', function () {
      clearTimeout(chakane);
      chakane = setTimeout(function () {
        var i = Math.round(lenta.scrollLeft / Math.max(1, lenta.clientWidth));
        if (i !== tekusht && i >= 0 && i < slaidove.length) oznachi(i);
      }, 120);
    }, { passive: true });
    lenta.addEventListener('pointerdown', spri, { passive: true });
    lenta.addEventListener('touchstart', spri, { passive: true });
    lenta.addEventListener('wheel', function (e) { if (Math.abs(e.deltaX) > Math.abs(e.deltaY)) spri(); }, { passive: true });

    // сама смяна - пауза, докато мишката или фокусът са върху банерите и докато разделът не се вижда
    sek.addEventListener('mouseenter', function () { pauza = true; });
    sek.addEventListener('mouseleave', function () { pauza = false; });
    sek.addEventListener('focusin', function () { pauza = true; });
    sek.addEventListener('focusout', function () { pauza = false; });
    if (avto > 0) {
      taimer = setInterval(function () {
        if (!pauza && !document.hidden) idi(tekusht + 1);
      }, avto * 1000);
    }

    window.addEventListener('resize', function () { idi(tekusht, true); });
    slaidove.forEach(function (s) {
      var img = s.querySelector('img');
      if (img && !img.complete) img.addEventListener('load', sredata);
    });

    // редакторът на темата: избран блок -> неговият банер, без сама смяна
    document.addEventListener('shopify:block:select', function (e) {
      var i = slaidove.indexOf(e.target);
      if (i >= 0) { spri(); idi(i, true); }
    });

    oznachi(0);
  }

  function vsichki(koren) {
    Array.prototype.forEach.call((koren || document).querySelectorAll('[data-t4-banneri]'), init);
  }
  vsichki();
  // редакторът на темата презарежда секцията - новият HTML иска нов init
  document.addEventListener('shopify:section:load', function (e) { vsichki(e.target); });
})();
